module.exports = __webpack_public_path__ + "static/media/011.c2311118.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/011.jpg
// module id = 358
// module chunks = 0